<template>
  <el-table :data="allData" :max-height="tableHeight" stripe style="width: 100%">
    <el-table-column type="index" width="50" label=" "></el-table-column>
    <el-table-column label="途经省份" align="center">
      <template slot-scope="scope">
        <span>{{scope.row.registProvince?scope.row.registProvince:'合计'}}</span>
      </template>
    </el-table-column>
    <el-table-column :render-header="renderStop" align="center">
      <template slot-scope="scope">
        <span style="color:#00A28A">{{format(scope.row.stopSubtotal?scope.row.stopSubtotal:scope.row.AllSubtotal)}}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" :render-header="renderStopLabel">
      <template slot-scope="scope">
        <span>{{format(scope.row.stop_80?scope.row.stop_80:scope.row.subtotal_80)}}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="50%(不含)-80%">
      <template slot-scope="scope">
        <span>{{format(scope.row.stop_50_80?scope.row.stop_50_80:scope.row.subtotal_50_80)}}</span>
      </template>
    </el-table-column>
    <el-table-column  align="center" label="30%(不含)-50%">
      <template slot-scope="scope">
        <span>{{format(scope.row.stop_30_50?scope.row.stop_30_50:scope.row.subtotal_30_50)}}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="不大于30%">
      <template slot-scope="scope">
        <span>{{format(scope.row.stop_0_30?scope.row.stop_0_30:scope.row.subtotal_30)}}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="0%">
      <template slot-scope="scope">
        <span>{{format(scope.row.stop_0?scope.row.stop_0:scope.row.subtotal_0)}}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    allData: {
      type: Array
    }
  },
  methods: {
    renderStop(h, { column }) {
      return (
        <span>
          <img
            style="display:inline-block;vertical-align:middle;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAKxSURBVDiNrZRdSFNhGMf/m578mNuUVERCh5YfZ+QynRBeFiVBYIHYRQWBKCHYx6QuuoggisKpBUJkF1GilYRJElgO9EI0j2a6dpxOxZk4saHT+dmZ5+lGj1Oby+h/+T7/98f7f56XR0ZEhP8ouT+DxeXE2db3CKgpQ25rAywu565+ma8Xji3M4U5fO16NWuBtkAG4mKDFXV02NGFq/8DplSXcM3fg6dA3CKLo8yWMXI4rSUdw+/AxRAeH7gTOCasw8hzK+W4seoRdY3lLEcjgBpsJA6uHmgnaBOqaXqB/9udfg7ZLGx6J72cubw4lVb3/n2EAoIuIArCth32z0yjjObwZs+7avw0xcjnyNSkoZfXQRURvBU4uLyA2JAwAMLHkxhPrVzwb6sOcsLoDpGaCUJikQ0nKURwIVcL7vgRMbKjGqVgNDKweicpwAIBb+IXnw/2oHOjB+OI84hQqXEvNQMHBNCiZfQCAEbcLRp7DZ4cdttwCgNZlm5+hos5mUtRWUF5bI3FOx0aJPKJIvMtJHlGUzjing/LaGklRW0FFnc1km58hIqId/9C5uoyqwV5UDfYiLTwKN7VZOBmrkeqfJsfw0PIFZpcTxcnpKE5OR2RQiFSXgJfaP8LAZkrNXV7zoGaUh5HnEBwQiPOaFLwes2JlzQMDq8eFBBYhAYHSMI18N15mn96MfN/cQaq6SsppqSeTwy5FWxNF+vBjmEq6WqhpYoTWvGKbHHbKaaknVV0lPTB37ow8J6yi2taPxwM9iAlR4JY2C+fikiCXyaRIIhHejQ/hkaULU8uLuJqagcJDOqjWh/TH5SCIIt7arTDyHNyCgFJWj7z4ZNTbB1HGc1AyDAysHvmaFATKti4sn9tmQ6YpO8r5bpim7DgRE4/rbCaOx8T79PsF7lV+F+xe9RvZSoWCrOOqqgAAAABJRU5ErkJggg=="
          />
          各类油站停靠<br/>车辆总计
        </span>
      )
    },
    renderStopLabel(h, { column }) {
      return h('span', [
        h('span', '大于80%(不含)'),
        ])
    },
    format(num) {
      if(num==undefined){
        return 0;
      }
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
  }
}
</script>